/**
 * Valores reutilizables en la aplicación.
 * Usuario que siempre debe tener acceso a las cuentas de correo (admin/gestión).
 */
export const DEFAULT_MAIL_ADMIN_WORKER_ID = "651842f3e9b2a2383d2b5769";
